"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestDataGenerator = void 0;
const __1 = require("../..");
class TestDataGenerator {
    constructor() {
        this.origin = {
            altitude: 0,
            longitude: 1,
            latitude: 1,
        };
        this.rootFormVersion = __1.IkeId.generate();
        this.form = this.createForm();
        this.poleForm = this.createPoleForm(this.form);
    }
    createForm() {
        const form = new __1.FormModel();
        form.state.version = this.rootFormVersion;
        this.configureForm(form);
        return form;
    }
}
exports.TestDataGenerator = TestDataGenerator;
//# sourceMappingURL=TestDataGenerator.js.map